// Vehicle validation utilities

// Get current year for validation
const getCurrentYear = () => new Date().getFullYear();

// Validate vehicle year
export const validateVehicleYear = (year) => {
  if (!year) return { valid: false, error: 'Year is required' };
  
  const yearNum = parseInt(year, 10);
  
  if (isNaN(yearNum)) {
    return { valid: false, error: 'Year must be a valid number' };
  }
  
  const currentYear = getCurrentYear();
  const minYear = 1940;
  const maxYear = currentYear + 1; // Allow next year for new models
  
  if (yearNum < minYear || yearNum > maxYear) {
    return { valid: false, error: `Year must be between ${minYear} and ${maxYear}` };
  }
  
  return { valid: true };
};

// Validate vehicle make
export const validateVehicleMake = (make) => {
  if (!make || make.trim().length === 0) {
    return { valid: false, error: 'Make is required' };
  }
  
  // Check if make contains only letters, spaces, hyphens, and numbers (for alphanumeric makes)
  const makePattern = /^[a-zA-Z0-9\s\-]+$/;
  if (!makePattern.test(make)) {
    return { valid: false, error: 'Make contains invalid characters' };
  }
  
  // Check minimum and maximum length
  const trimmedMake = make.trim();
  if (trimmedMake.length < 2) {
    return { valid: false, error: 'Make must be at least 2 characters' };
  }
  
  if (trimmedMake.length > 50) {
    return { valid: false, error: 'Make must be less than 50 characters' };
  }
  
  return { valid: true };
};

// Validate vehicle model
export const validateVehicleModel = (model) => {
  if (!model || model.trim().length === 0) {
    return { valid: false, error: 'Model is required' };
  }
  
  // Allow letters, numbers, spaces, hyphens, periods, and slashes (for model variants like "F-150", "3 Series", "CX-5")
  const modelPattern = /^[a-zA-Z0-9\s\-\.\/]+$/;
  if (!modelPattern.test(model)) {
    return { valid: false, error: 'Model contains invalid characters' };
  }
  
  // Check minimum and maximum length
  const trimmedModel = model.trim();
  if (trimmedModel.length < 1) {
    return { valid: false, error: 'Model must be at least 1 character' };
  }
  
  if (trimmedModel.length > 50) {
    return { valid: false, error: 'Model must be less than 50 characters' };
  }
  
  return { valid: true };
};

// Validate all vehicle fields
export const validateVehicle = (year, make, model) => {
  const yearValidation = validateVehicleYear(year);
  const makeValidation = validateVehicleMake(make);
  const modelValidation = validateVehicleModel(model);
  
  const errors = {};
  
  if (!yearValidation.valid) {
    errors.year = yearValidation.error;
  }
  
  if (!makeValidation.valid) {
    errors.make = makeValidation.error;
  }
  
  if (!modelValidation.valid) {
    errors.model = modelValidation.error;
  }
  
  return {
    valid: Object.keys(errors).length === 0,
    errors
  };
};